// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__uSJqa","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__AGFdQ"};